<template>
    <button
        class="marketplace-nav-btn"
        :class="{ 'marketplace-nav-btn--active': isMarketplaceRoute }"
        type="button"
        @click="goToMarketplace"
    >
        <v-icon class="market-icon" size="18" color="currentColor">$marketplace</v-icon>
        <span class="market-label">Маркетплейс</span>
    </button>
</template>

<script>
export default {
    name: 'MarketplaceNavButton',
    computed: {
        isOnProjectRoute() {
            return this.$route.path.startsWith('/project/')
        },
        projectId() {
            return this.$route.params?.id
        },
        isMarketplaceRoute() {
            return this.$route.path.includes('/marketplace')
        },
        targetMarketplacePath() {
            if (this.$auth?.isAuthenticated && this.isOnProjectRoute && this.projectId) {
                return `/project/${this.projectId}/marketplace`
            }
            return '/marketplace'
        },
    },
    methods: {
        goToMarketplace() {
            if (this.$route.path === this.targetMarketplacePath) return
            this.$router.push(this.targetMarketplacePath).catch(() => {})
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.marketplace-nav-btn
    height: 36px
    min-width: 154px
    border-radius: 10px
    border: 3px solid rgba(255, 184, 80, .58)
    background: linear-gradient(135deg, #FF8D13 0%, #FF6B15 46%, #FF5438 100%)
    color: #fff
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 9px
    padding: 0 14px
    font-size: 12.5px
    font-weight: 900
    letter-spacing: -.01em
    line-height: 1
    cursor: pointer
    text-shadow: 0 1px 0 rgba(0, 0, 0, .08)
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .22), 0 5px 14px rgba(242, 98, 10, .28)
    transition: transform .15s ease, box-shadow .15s ease, background .15s ease

    &:hover
        transform: translateY(-1px)
        background: linear-gradient(135deg, #FF7F10 0%, #F2620A 46%, #F0442D 100%)
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .22), 0 6px 16px rgba(242, 98, 10, .36)

    &:active
        transform: translateY(0)

    &:focus-visible
        outline: 2px solid rgba(255, 255, 255, .9)
        outline-offset: 2px

    ::v-deep .v-icon
        color: inherit !important

    .market-label
        color: #fff !important

.marketplace-nav-btn--active
    background: linear-gradient(135deg, #FF7F10 0%, #F2620A 46%, #F0442D 100%)
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .22), 0 6px 16px rgba(242, 98, 10, .36)

.market-icon
    flex: 0 0 auto

@media (max-width: 980px)
    .marketplace-nav-btn
        min-width: auto
        padding-inline: 12px

    .market-label
        display: none

@media (max-width: 760px)
    .marketplace-nav-btn
        width: 38px
        min-width: 38px
        height: 34px
        padding: 0
        gap: 0
        border-width: 2px
        border-radius: 9px
</style>
